// PannelliLaterali.tsx
import React, { useMemo } from "react";
import { Edges } from "@react-three/drei";
import * as THREE from "three";
import { Point3D } from "../common_types";

type PannelliLateraliProps = {
  numeroPannelli: number;
  altezzaPilastro: number;
  sezionePilastro: { larghezza: number; altezza: number };
  texture: THREE.Texture;
  direzione: "Destra" | "Sinistra" | "Fronte" | "Retro";
  verso: "positivo" | "negativo";
  csPilastroEsterno: Point3D;
};

const LARGHEZZA_PANNELLO = 0.04;
const SPESSORE_PANNELLO = 0.14;
const SPACING = 0.04;

export const PannelliLaterali: React.FC<PannelliLateraliProps> = ({
  numeroPannelli,
  altezzaPilastro,
  sezionePilastro,
  texture,
  direzione,
  verso,
  csPilastroEsterno,
}) => {
  const basePosition = useMemo(() => {
    const x = csPilastroEsterno.x;
    const y = csPilastroEsterno.y;
    const z = csPilastroEsterno.z;

    let offsetX = 0;
    let offsetY = 0;

    if (direzione === "Destra") {
      offsetX = sezionePilastro.larghezza / 2 + SPESSORE_PANNELLO / 2;
    } else if (direzione === "Sinistra") {
      offsetX = -sezionePilastro.larghezza / 2 - SPESSORE_PANNELLO / 2;
    } else if (direzione === "Fronte") {
      offsetY = -sezionePilastro.altezza / 2 - SPESSORE_PANNELLO / 2;
    } else if (direzione === "Retro") {
      offsetY = sezionePilastro.altezza / 2 + SPESSORE_PANNELLO / 2;
    }

    return { x: x + offsetX, y: y + offsetY, z };
  }, [direzione, csPilastroEsterno, sezionePilastro]);

  const rotation = useMemo(() => {
    return new THREE.Euler(0, 0, 0);
  }, [direzione]);

  const startOffset = useMemo(() => {
    if (direzione === "Destra" || direzione === "Sinistra") {
      return -sezionePilastro.altezza / 2 + LARGHEZZA_PANNELLO / 2;
    } else {
      return -sezionePilastro.larghezza / 2 + LARGHEZZA_PANNELLO / 2;
    }
  }, [direzione, sezionePilastro]);

  return (
    <group>
      {Array.from({ length: numeroPannelli }, (_, i) => {
        const offset = i * (LARGHEZZA_PANNELLO + SPACING);

        let posX = basePosition.x;
        let posY = basePosition.y;
        let posZ = basePosition.z + 0.035;

        if (direzione === "Destra" || direzione === "Sinistra") {
          if(verso === 'positivo'){
            posY += startOffset + offset;
          }else{
            posY += startOffset - offset;
          }
        } else {
          if(verso === 'positivo'){
            posX += startOffset + offset;
          }else{
            posX += startOffset - offset;
          }
        }
        return (
          <mesh
            key={i}
            position={[posX, posY, posZ]}
            rotation={rotation}
          >
            <boxGeometry
              args={[
                direzione === "Fronte" || direzione === "Retro"
                  ? LARGHEZZA_PANNELLO
                  : SPESSORE_PANNELLO,
                direzione === "Fronte" || direzione === "Retro"
                  ? SPESSORE_PANNELLO
                  : LARGHEZZA_PANNELLO,
                altezzaPilastro + 0.07,
              ]}
            />
            <meshStandardMaterial map={texture} />
            <Edges color="#363636" />
          </mesh>
        );
      })}
    </group>
  );
};